module.exports = __webpack_public_path__ + "img/cjly.408d527e.png";